import { useMemo } from "react";
import ReactTable from "react-table-6";
import ReactTablePagination from "../../../custom/growth/ProductsCVTablePagination";
import FormGroupTile from "../../../core/basic/FormGroupTile";
import useColumnSelector from "../../../../hooks/useColumnSelector";
import { MARKETPLACE_CURRENCY_DENOMINATION } from "../../../../utils/marketplaceConstants";
import { getURLPrefix } from "../../../../utils/getUrlPrefix";
import { Checkbox } from "../../../fields/base/Checkbox";
import { useTranslation } from "react-i18next";

const URL_PREFIX = getURLPrefix();

const EditCell = (props) => {
  const { t } = useTranslation(["merchandising"]);
  const { id, fulfillment_channel } = props.original ?? {};

  if (props.column.format === "checkbox") {
    const { id } = props.original ?? {};

    return (
      <div className="d-flex justify-content-center">
        <Checkbox
          value={props.original[props.column.id]}
          onChange={() => {
            props.column.handleUpdate(id, props.column.id, !props.original[props.column.id]);
          }}
        />
      </div>
    );
  }
  return (
    <FormGroupTile
      type="formcontrol"
      decimalInput={props.column.format === "currency" || props.column.format === "number"}
      stateName={props.stateName}
      handleChildFormElement={(key, value) => {
        if (props.column.format === "number" || props.column.format === "currency") {
          if (/^\d*\.?\d*$/.test(value) || value === "") {
            props.column.handleUpdate(id, props.column.id, value);
          }
          return;
        }
        props.column.handleUpdate(id, props.column.id, value);
      }}
      disabled={props.column.id === "shipping_cost" && fulfillment_channel === "AFN"}
      formControlClass="no-arrows text-center"
      value={props.original[props.column.id]}
      placeholder={
        props.column.id === "shipping_cost" && fulfillment_channel === "AFN" ?
          t(($) => $.merchandising["Fulfilled by Amazon"])
        : props.column.format === "currency" ?
          `${MARKETPLACE_CURRENCY_DENOMINATION[props.column.marketPlace]}`
        : null
      }
    />
  );
};

const ProductDetailsDialogue = ({ products, marketPlace, updateLandedCostDetails, landedCostDetails }) => {
  const { t } = useTranslation(["merchandising"]);
  const handleProductDetailsUpdate = (id, key, value) => {
    const updatedProductDetails = products;
    updatedProductDetails.find((c) => c.id === id)[key] = value;
    updateLandedCostDetails(updatedProductDetails);
  };

  const [productColumns] = useColumnSelector(() => {
    const columns = [
      {
        id: "product",
        Header: t(($) => $.merchandising["Product"]),
        width: 290,
        style: {
          textAlign: "left",
          color: "rgb(115, 112, 110)",
          cursor: "pointer",
        },
        Cell: (props) => {
          const productId = props?.original?.id;
          const image = `${URL_PREFIX}/api/productimage/?product=${productId}`;
          return (
            <div style={{ display: "flex" }}>
              <div
                style={{
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  flexShrink: 0,
                  width: 50,
                  height: 50,
                  marginRight: "10px",
                  background: `url(${image}) no-repeat center / contain`,
                }}
                draggable="false"
              />
              <div>
                {props?.original.product_title}
                <br />
                <i
                  style={{
                    fontWeight: "light",
                    color: "#666",
                    fontSize: "1rem",
                  }}
                >
                  {props?.original.asin} ({props?.original.sku})
                </i>
              </div>
            </div>
          );
        },
        accessor: "name",
        filterMethod: () => true,
        Filter: () => null,
      },
      {
        id: "landed_cost",
        accessor: "landed_cost",
        Header: t(($) => $.merchandising["Landed Cost"]),
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        width: 200,
        Cell: EditCell,
        handleUpdate: handleProductDetailsUpdate,
        format: "currency",
        marketPlace: marketPlace,
        filterMethod: () => true,
        Filter: () => null,
      },
      {
        id: "shipping_cost",
        accessor: "shipping_cost",
        Header: t(($) => $.merchandising["Shipping Cost"]),
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        width: 200,
        Cell: EditCell,
        handleUpdate: handleProductDetailsUpdate,
        format: "currency",
        marketPlace: marketPlace,
        filterMethod: () => true,
        Filter: () => null,
      },
    ];
    return columns;
  }, [landedCostDetails]);

  const filteredProducts = useMemo(() => {
    const filtered = products.filter((p) => p && (!p?.landed_cost || typeof p?.landed_cost === "string"));
    return filtered;
  }, [products]);

  return (
    <ReactTable
      className="pe-5"
      showPaginationTop={true}
      showPaginationBottom={false}
      showPageSizeOptions={false}
      defaultPageSize={10}
      // Below is needed to eliminate the no data message that covers table headers if no data to render
      NoDataComponent={() => null}
      minRows={0}
      columns={productColumns}
      PaginationComponent={ReactTablePagination}
      getPaginationProps={() => ({
        clearFilters: () => {},
        hideFilters: true,
        table: "category-targetting-params",
        style: { marginBottom: "1rem" },
        carouselLayout: false,
        disableSearchFocus: true,
        searchWidth: "280px",
        hideSearch: true,
        singlePage: true,
      })}
      style={{
        borderRadius: "15px",
        border: "none",
        boxShadow: "none",
      }}
      data={filteredProducts ?? []}
      filterable={false}
      sortable={false}
    />
  );
};

export default ProductDetailsDialogue;
